import React from 'react';
import * as S from './styles';

export default function DescriptionText() {
	return (
		<S.container>
			<h1>DescriptionText</h1>
		</S.container>
	);
}
